import React from 'react';
import { Typography } from 'antd';
import { useTheme } from '@material-ui/core';

import './EmptyStateSection.less';

const { Title, Text } = Typography;

interface EmptyStateSectionProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
  className?: string;
}

const EmptyStateSection = ({
  icon,
  title,
  description,
  className = '',
}: EmptyStateSectionProps) => {
  const { palette } = useTheme();

  return (
    <div
      className={`empty-state-section ${className}`}
      style={{
        textAlign: 'center',
        padding: '48px 24px',
        backgroundColor: palette.grey[50],
        borderRadius: '8px',
        border: `1px dashed ${palette.grey[300]}`,
      }}
    >
      {icon ? (
        <div
          className="empty-state-section__icon"
          style={{
            fontSize: '48px',
            color: palette.grey[400],
            marginBottom: '16px',
          }}
        >
          {icon}
        </div>
      ) : null}
      <Title
        level={4}
        style={{ color: palette.grey[600], marginBottom: '8px' }}
        className="empty-state-section__title"
      >
        {title}
      </Title>
      <Text
        type="secondary"
        style={{ fontSize: '16px' }}
        className="empty-state-section__description"
      >
        {description}
      </Text>
    </div>
  );
};

export default EmptyStateSection;
